const getters = {
  token: state => state.login.token,
  roles: state => state.login.roles,
  perm: state => state.login.perm,
  addrouters: state => state.permission.addRouters,
  routers: state => state.permission.routers
}
export default getters
